<script setup lang="ts">
    import { computed, toRef } from 'vue'

    import { KendoGrid } from '@Kendo/Components/KendoGrid'
    import KendoGridColumnsEditorDialog from '@Kendo/Components/KendoGridColumnsEditorDialog.vue'

    import type { ProjectsGridViewModel } from '@Quest/Projects/Components/ProjectsGrid'

    // ---------------- props ----------------

    const props = defineProps<{
        viewModel: ProjectsGridViewModel
    }>()

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const grid = computed<KendoGrid | null>(() =>
        vm.value?.grid ?? null
    )

    const columnsEditorDialogOpened = computed<boolean>(() =>
        vm.value?.columnsEditorOpened ?? false
    )

    // ---------------- actions ----------------

    function closeColumnsEditor()
    {
        vm.value.columnsEditorOpened = false
    }
</script>


<template>
    <div class="portfolio-grid">
        <KendoGridColumnsEditorDialog :propOpened="columnsEditorDialogOpened"
                                      :propGrid="grid"
                                      @close-dialog="closeColumnsEditor" />

        <div id="pbGrid"></div>
    </div>
</template>

<style>
    /* Ensure dropdown visibility */
    .portfolio-grid .k-grid td {
        overflow: visible !important;
    }

    .k-table-tbody .k-table-row.k-selected > .k-table-td {
        background-color: #ffffff;
    }

    .k-table-tbody .k-table-row.k-alt.k-selected > .k-table-td {
        background-color: #f1f1f1;
    }
</style>

